"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHu_socketio_events = void 0;
exports.SHu_socketio_events = {
    uwuBulk_creatorPing: {
        event: "uwuBulk_creatorPing",
        createPayload: (p) => ["uwuBulk_creatorPing", p],
    },
    uwuBulk_browsersPing: {
        event: "uwuBulk_browsersPing",
        createPayload: (p) => ["uwuBulk_browsersPing", p],
    },
};
